import { appFormUtil } from 'modules/common';
import React from 'react';

type IFormState = {
  newTasks: boolean;
  assigned: boolean;
  overdue: boolean;
  inApproval: boolean;
  completed: boolean;
};

const initialState: IFormState = {
  newTasks: false,
  assigned: false,
  overdue: false,
  inApproval: false,
  completed: false
};

export function useFormState() {
  const {
    formState,
    dispatch,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      newTasks: {
        label: 'New',
        type: 'checkbox'
      },
      assigned: {
        label: 'Assigned',
        type: 'checkbox'
      },
      overdue: {
        label: 'Overdue',
        type: 'checkbox'
      },
      inApproval: {
        label: 'In Approval',
        type: 'checkbox'
      },
      completed: {
        label: 'Completed',
        type: 'checkbox'
      }
    }
  });

  return React.useMemo(
    () => {


      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}
